export default "__VITE_ASSET__d5a79532__"